import { render, staticRenderFns } from "./ReferralTypeList.vue?vue&type=template&id=e30ca8ee&scoped=true"
import script from "./ReferralTypeList.vue?vue&type=script&lang=js"
export * from "./ReferralTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30ca8ee",
  null
  
)

export default component.exports